module.exports = __webpack_public_path__ + "static/media/Household.9509c0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/householdProducts/Household.jpg
// module id = 213
// module chunks = 0